<template>
  <div class="container">
    <div class="header">
      <h1>Jaktřídit.info</h1>
      <router-link class="btn btn-about" to="/about">O projektu</router-link>
    </div>
    <MaterialCard :data="materials" />
  </div>
</template>

<script>
// @ is an alias to /srcF
import data from '@/data/data.js'
import MaterialCard from '@/components/MaterialCard.vue'

export default {
  name: 'home',
  components: {
    MaterialCard
  },
  data() {
    return {
      materials: data.materials
    }
  },
  methods: {},
  created() {},
  mounted() {}
}
</script>
